export const ShipSmarterData = [
 {
  imageName: 'static/img/cml/faster-clearance-times.png',
  title: 'Faster Clearance Times',
  description:
   'Our efficient customs handling ensures your shipments are cleared promptly, ensuring your goods arrive quickly and hassle-free.',
 },
 {
  imageName: 'static/img/cml/items-delivered-good-condition.png',
  title: 'Items Delivered in Good Condition',
  description:
   'From packaging to final delivery, we handle every shipment with care to ensure your items arrive in perfect condition.',
 },
 {
  imageName: 'static/img/cml/large-delivery-network.png',
  title: 'Large Delivery Network',
  description:
   'Leveraging a broad and continually expanding delivery network, we guarantee dependable, timely service wherever your packages need to go.',
 },
 {
  imageName: 'static/img/cml/instant-tracking-on-arrival.png',
  title: 'Instant Tracking on Arrival',
  description:
   'Receive instant and accurate tracking updates as soon as your shipment arrives in Nigeria, giving you full visibility from arrival to final delivery.',
 },
];
